module.exports = __webpack_public_path__ + "img/title-bg.3ac65098.png";